<div class="container-fluid historical-data-container">
  <div class="page-header">

    <wfm-page-title title="{{'historical-data.page.title'|translate}}"></wfm-page-title>
    <div class="text-right">
      <button *ngIf="hasEspModifyPermission" id="cancel" (click)="discardChanges()"
              class="btn btn-secondary btn-lg no-right-margin"
              [ngClass]="{'disabled': _isLoading || _isPristine || _isEditing}"
              [disabled]="_isLoading || _isPristine || _isEditing"
              title='{{"historical-data.discard.btn" | translate}}'>{{"historical-data.discard.btn" | translate}}</button>
      <button *ngIf="hasEspModifyPermission" id="apply" (click)="saveChanges()"
              class="btn btn-primary btn-lg no-right-margin"
              [ngClass]="{'disabled': _isLoading || _isGridValid==false || _isPristine || _isEditing}"
              [disabled]="_isLoading || _isGridValid==false || _isPristine || _isEditing"
              title='{{"historical-data.save.btn" | translate}}'>{{"historical-data.save.btn" | translate}}</button>
    </div>
  </div>
  <div class="toolbar-container vertical-items text-left no-gutters">
    <div class="toolbar-vertical-item ">
      <span class="toolbar-label">{{"historical-data.ct.dropdown.label" | translate}}</span>
      <p-multiselect placeholder=" " #ctSelector
                     [ariaLabel]="'historical-data.ct.dropdown.label' | translate"
                     (click)="onMultiselectContainerClick($event, ctSelector)"
                     class="filterable ct-selector"
                     appendTo="body"
                     [(ngModel)]="selectedCTs"
                     ngDefaultControl
                     [options]="ctList"
                     [showToggleAll]="false"
                     [virtualScroll]="true"
                     optionLabel="value.label"
                     optionValue="value"
                     [virtualScrollItemSize]="40"
                     (onChange)="updateSelectedCTs($event)"
                     [showHeader]="true"
                     [filter]="false"
                     [disabled]="!_isGridValid || _isLoading"
                     emptyFilterMessage="{{'historical-data.ct.no.results.found' | translate}}"
                     styleClass="fullrow">
        <ng-template let-value pTemplate="selectedItems">
          <!--<ng-container
            *ngTemplateOutlet="multiSelectSelectedItems;
            context: { value: value, emptyMessage: 'historical-data.ct.empty.selection' }">
          </ng-container>-->
          <esp-multi-select-content [items]="value" emptyMessage="historical-data.ct.empty.selection"> </esp-multi-select-content>
        </ng-template>
        <ng-template pTemplate="header">
          <esp-multi-select-filter [multiSelect]="ctSelector"
            [searchAriaLabel]="'multi.select.filter.search.contact.types' | translate">

          </esp-multi-select-filter>
        </ng-template>
        <ng-template pTemplate="footer">
          <esp-multi-select-footer [multiSelect]="ctSelector">

          </esp-multi-select-footer>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <!--<ng-container *ngTemplateOutlet="multiSelectItem; context:  { $implicit: item }"></ng-container>-->
          <esp-multi-select-item [item]="item"></esp-multi-select-item>

        </ng-template>
      </p-multiselect>
    </div>
    <div class="toolbar-vertical-item ">
      <span class="toolbar-label">{{"historical-data.parameters.dropdown.label" | translate}}</span>
      <p-multiselect placeholder=" " #paramSelector
                     [ariaLabel]="'historical-data.parameters.dropdown.label' | translate"
                     (click)="onMultiselectContainerClick($event, paramSelector)"
                     [(ngModel)]="selectedParams"
                     ngDefaultControl
                     class="filterable"
                     appendTo="body"
                     [options]="paramsList"
                     [showToggleAll]="false"
                     [virtualScroll]="true"
                     optionLabel="value.label"
                     optionValue="value"
                     [virtualScrollItemSize]="40"
                     scrollHeight="100px"
                     [disabled]="!_isGridValid || _isLoading"
                     [filter]="false"
                     (onChange)="updateSelectedParams($event)"
                     [showHeader]="false"
                     styleClass="fullrow">
        <ng-template let-value pTemplate="selectedItems">
          <!--<ng-container
            *ngTemplateOutlet="multiSelectSelectedItems;
            context: { value : value, emptyMessage:'historical-data.params.empty.selection' }">
          </ng-container>-->
          <esp-multi-select-content [items]="value" emptyMessage="historical-data.params.empty.selection"> </esp-multi-select-content>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <!--<ng-container *ngTemplateOutlet="multiSelectItem; context:  { $implicit: item }"></ng-container>-->
          <esp-multi-select-item [item]="item"></esp-multi-select-item>

        </ng-template>
      </p-multiselect>
    </div>
    <div class="toolbar-vertical-item">
      <span class="toolbar-label">{{"historical-data.date.range.label" | translate}}</span>
      <div class="datepicker-wrapper">
        <p-select [options]="datePresets"
                    [ariaLabel]="'historical-data.date.range.label' | translate"
                    [(ngModel)]="selectedPreset"
                    [filter]="false"
                    optionLabel="name"
                    [disabled]="!_isGridValid || _isLoading"
                    optionValue="value"
                    appendTo="body"
                    panelStyleClass="date-preset-panel"
                    emptyMessage="''"
                    (onChange)="onPresetDateRangeChange()">
          <ng-template let-item pTemplate="item">
            <span title="{{item.name | translate}}">{{item.name | translate}}</span>
          </ng-template>
          <ng-template let-item pTemplate="selectedItem">
            <span title="{{item.name | translate}}">{{item.name | translate}}</span>
          </ng-template>
        </p-select>
        <p-datepicker [(ngModel)]="rangeDates"
                    [disabled]="selectedPreset!='CUSTOM_RANGE' || !_isGridValid || _isLoading"
                    ngDefaultControl
                    espDatepickerDayAriaLabels
                    [showOnFocus]="false"
                    class="range-picker"
                    [ngClass]="{'disabled':selectedPreset!='CUSTOM_RANGE'}"
                    panelStyleClass="range-picker"
                    selectionMode="range"
                    [readonlyInput]="true"
                    appendTo="body"

                    showIcon="true"
                    placeholder="{{'calendar.date.range' | translate}}"
                    readonlyInput="true"
                    (onSelect)="onDateRangeChange()"
                    [maxDate]="maxDateRange"
                    [minDate]="minDateRange"
                    [dateFormat]="'prime.calendar.format' | translate"
                    (onClose)="onDateRangeClosed()"
                    inputId="range">
          <ng-template #triggericon>
            <esp-icon name="chevron-down"></esp-icon>
          </ng-template>
        </p-datepicker>
      </div>

    </div>
  </div>
  <div class="table-list editable-grid multi-cell-edit">
    <ag-grid-angular class="ag-theme-balham"
                     #grid
                     [rowHeight]="36"
                     [headerHeight]="40"
                     [rowClassRules]="rowClassRules"
                     [columnDefs]="colDefs"
                     [rowData]="rowData"
                     [gridOptions]="gridOptions"
                     [noRowsOverlayComponent]="'noRowsOverlay'"
                     [noRowsOverlayComponentParams]="noRowsComponentParams"
                     [suppressRowTransform]="true"
                     [defaultColDef]="defaultColDef"
                     [loading]="false"
                     [icons]="icons"
                     [cellSelection]="cellSelection"
                     [rowSelection]="rowSelection"
                     [stopEditingWhenCellsLoseFocus]="true"
                     [animateRows]="false"
                     [components]="frameworkComponents"
                     [loadingOverlayComponent]="'loadingRowsOverlayComponent'"
                     [loadingOverlayComponentParams]="loadingOverlayParams"
                     [context]="gridContext"
                     (gridReady)="onGridReady($event)"
                     (sortChanged)="onSortChanged()"
                     (newColumnsLoaded)="onNewColumnsLoaded()"
                     [enableBrowserTooltips]="true"
                     (cellEditingStarted)="cellEditingStarted($event)"
                     (cellEditingStopped)="cellEditingStopped($event)"
                     (cellValueChanged)="cellValueChanged($event)">
    </ag-grid-angular>
  </div>
</div>
<p-toast position="bottom-right" [baseZIndex]="50">
</p-toast>
<div class="dialog-container"></div>
<!-- Blocks the filters while the CT list loads; the grid shows skeleton rows. -->
<div class="overlay-panel initializing-blocker" *ngIf="_isInitializing"></div>

<!--<ng-template let-value="value" let-empty="emptyMessage" #multiSelectSelectedItems>
  <div class="ui-multiselected-item-token">
            <span *ngIf='value && value.length > 1' title='{{value.length}} {{"multiselect.text"|translate}}'>
              {{value.length}} {{"multiselect.text"|translate}}
            </span>
    <span *ngIf='value && value.length == 1' title='{{value[0].label | translate}}'>{{value[0].label | translate}}</span>
  </div>
  <span *ngIf="!value || value.length === 0"
        class="ui-multiselected-empty-token" title="{{empty|translate}}">{{empty|translate}}</span>
</ng-template>-->


<!--<ng-template let-item #multiSelectItem>
  <div title="{{item.value.label | translate}}" class="ui-multiselect-item-custom
                                    {{item.value.preferred?'multiselect-bg-white':'multiselect-bg-gray'}}
                                    {{item.separator?'item-separator':''}}">
    <div class="checkbox">
      <input type="checkbox" [checked]="item.isSelected"/>
      <label class="ui-multiselect-option-label" [ngClass]="{'read-only':item.isReadOnly}">
        <span class="label-text">{{item.value.label | translate}}</span>
      </label>
    </div>
  </div>
</ng-template>-->
